import { Zap, X } from 'lucide-react';

const MESSAGES = {
  CENTRO_LIMIT: {
    icon: '🏢',
    title: 'Necesitas más centros de trabajo',
    subtitle: 'Tu plan actual ha alcanzado el límite de centros incluidos.',
    cta: 'Ver planes disponibles',
  },
  TRABAJADOR_LIMIT: {
    icon: '👥',
    title: 'Límite de trabajadores alcanzado',
    subtitle: 'Tu plan actual no permite agregar más trabajadores.',
    cta: 'Ampliar mi plan',
  },
  GUIA_LIMIT: {
    icon: '📋',
    title: 'Esta guía no está incluida en tu plan',
    subtitle: 'Actualiza para acceder a todas las guías de evaluación.',
    cta: 'Desbloquear guías',
  },
};

export default function UpgradeModal({ error, onClose }) {
  if (!error) return null;

  const config = MESSAGES[error.code] || {
    icon: '⚡',
    title: 'Actualiza tu plan',
    subtitle: error.message || 'Has alcanzado un límite de tu plan actual.',
    cta: 'Ver planes',
  };

  return (
    <div style={{
      position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
      background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center',
      justifyContent: 'center', zIndex: 9999, padding: 20,
    }} onClick={onClose}>
      <div style={{
        background: '#fff', borderRadius: 20, padding: '40px 36px',
        maxWidth: 420, width: '100%', textAlign: 'center',
        boxShadow: '0 20px 60px rgba(0,0,0,0.15)', position: 'relative',
      }} onClick={e => e.stopPropagation()}>

        {/* Close */}
        <button onClick={onClose} style={{
          position: 'absolute', top: 16, right: 16, background: 'none',
          border: 'none', cursor: 'pointer', color: '#94a3b8', padding: 4,
        }}><X size={20} /></button>

        {/* Icon */}
        <div style={{ fontSize: '3rem', marginBottom: 16 }}>{config.icon}</div>

        {/* Title */}
        <h2 style={{ fontSize: '1.3rem', fontWeight: 700, color: '#1e293b', margin: '0 0 8px' }}>
          {config.title}
        </h2>

        {/* Detail from API */}
        <p style={{ color: '#64748b', fontSize: '0.9rem', lineHeight: 1.5, margin: '0 0 8px' }}>
          {config.subtitle}
        </p>

        {/* Show current vs limit */}
        {error.current !== undefined && error.limit !== undefined && (
          <div style={{
            display: 'inline-flex', gap: 16, padding: '12px 20px',
            background: '#f8fafc', borderRadius: 10, margin: '12px 0 20px',
          }}>
            <div>
              <div style={{ fontSize: '1.4rem', fontWeight: 700, color: '#ef4444' }}>{error.current}</div>
              <div style={{ fontSize: '0.7rem', color: '#94a3b8' }}>Actual</div>
            </div>
            <div style={{ width: 1, background: '#e2e8f0' }} />
            <div>
              <div style={{ fontSize: '1.4rem', fontWeight: 700, color: '#6366f1' }}>{error.limit}</div>
              <div style={{ fontSize: '0.7rem', color: '#94a3b8' }}>Límite</div>
            </div>
          </div>
        )}

        {/* CTA */}
        <button onClick={() => { window.location.href = '/planes?upgrade=true'; }} style={{
          display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 8,
          width: '100%', padding: '14px 24px', background: '#6366f1', color: '#fff',
          border: 'none', borderRadius: 12, fontSize: '0.95rem', fontWeight: 600,
          cursor: 'pointer', marginTop: 8,
        }}>
          <Zap size={18} /> {config.cta}
        </button>

        {/* Dismiss */}
        <button onClick={onClose} style={{
          background: 'none', border: 'none', color: '#94a3b8',
          fontSize: '0.82rem', cursor: 'pointer', marginTop: 12, padding: 4,
        }}>
          Ahora no
        </button>
      </div>
    </div>
  );
}
